var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#183028"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8948 8.55669L18.6442 8.30964C18.4457 8.11137 18.1766 8 17.896 8C17.6154 8 17.3463 8.11137 17.1478 8.30964L13.4527 12.0012L9.76109 8.30964C9.56257 8.11137 9.29347 8 9.01289 8C8.73231 8 8.46321 8.11137 8.26469 8.30964L8.01412 8.55669L12.4433 13L8 17.4398L8.25057 17.6904C8.44909 17.8886 8.71819 18 8.99877 18C9.27935 18 9.54845 17.8886 9.74697 17.6904L13.4386 13.9988L17.1337 17.6904C17.3322 17.8886 17.6013 18 17.8819 18C18.1624 18 18.4315 17.8886 18.6301 17.6904L18.8806 17.4398L14.4373 13L18.8948 8.55669Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelStatus);
export default __webpack_public_path__ + "static/media/cancel-status.5249766e1d20f4404cc2d4f497ed06b7.svg";
export { ForwardRef as ReactComponent };